export const ShannonDunn = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="shannonDunnModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/shannondunn-modal.png"
                    alt="Shannon Dunn"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Shannon Dunn
                    </h4>
                    <p>Architectural Designer</p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      Ms Dunn has pursued a passion for infusing health and
                      wellness into the built environment since 1998 when she
                      earned an undergraduate degree in Design of the
                      Environment at the University of Pennsylvania. She went on
                      to achieve a Master of Architecture also at Penn in 2004.
                    </p>

                    <p>
                      She began her association with Big Blue Fish in 2006 and
                      partnered to explore the intersection of design and health
                      with DELOS. She was an integral part of the original team
                      exploring the integration of wellness strategies with air,
                      water, light and material features.
                    </p>

                    <p>
                      Shannon continues to pursue wellness in education,
                      residential and contract interiors and spa design for
                      various locations and building typologies. A mother of
                      two, Shannon’s passion for creating healthier spaces has
                      only deepened. She continues to push the envelope of what
                      it means to design wellness systems with our team.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
